import { render } from "./SheetMenu.vue?vue&type=template&id=850b3de0&scoped=true"
import script from "./SheetMenu.vue?vue&type=script&lang=js"
export * from "./SheetMenu.vue?vue&type=script&lang=js"

import "./SheetMenu.vue?vue&type=style&index=0&id=850b3de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-850b3de0"

export default script